import { useEffect, useState } from 'react'

// Define the props type
interface ProgressSpinnerProps {
  percentage: number // percentage should be a number
}

const ProgressSpinner: React.FC<ProgressSpinnerProps> = ({ percentage }) => {
  const [rotation, setRotation] = useState(0)

  // Update the rotation based on the percentage
  useEffect(() => {
    setRotation((percentage / 100) * 360) // Rotate based on the percentage
  }, [percentage])

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <i
        className='fa fa-spinner fa-spin'
        style={{
          fontSize: '36px',
          transform: `rotate(${rotation}deg)`,
          transition: 'transform 0.3s ease-out', // Smooth transition for the spinner
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '16px',
          color: 'black',
        }}>
        {percentage}%
      </div>
    </div>
  )
}

export default ProgressSpinner
